import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

const routes = [
    {path: '/',redirect: '/home'},
    {path: '/home',component: (resolve) => {require(['./pages/home.vue'],resolve)}},
    {path: '/related-list',component: (resolve) => {require(['./pages/related-list'],resolve)}},
    {path: '/common-list',component: (resolve) => {require(['./pages/common-list'],resolve)}},
]

let router = new VueRouter({routes})

export default router